<template>
  <el-dialog
    title="Login"
    :visible.sync="value"
    width="400px"
    :before-close="handleClose"
  >
    <img src="@/images/airudderLogo.png" />
    <el-button icon="iconfont icon-google" type="primary" :loading="loading" @click="auth">&nbsp;&nbsp;Log in with Google</el-button>
    <div style="text-align: center;">
      <a class="link" :href="origin + '/privacy'" target="_blank">Privacy Policy</a>
    </div>
  </el-dialog>
</template>

<script>
import { getAuthInit } from '@/api/extra'

export default {
  model: {
    prop: 'value',
    event: 'returnModel'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      origin: window.origin
    }
  },
  methods: {
    handleClose() {
      this.$emit('returnModel', false)
    },
    async auth() {
      this.loading = true
      try {
        const res = await getAuthInit()
        if (this.$checkReq(res)) {
          window.location.href = res.data.data.auth_address
          this.handleClose()
        }
      } catch (err) {}
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
img{
  width: 280px;
  display: block;
  margin: 0 auto;
}
.el-button{
  width: 100%;
  margin: 20px 0 60px 0;
}
.link{
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/gcplog/login.vue